import type { CSSProperties, ReactNode, RefObject } from "react";
import { forwardRef } from "react";

import { Tooltip as ChakraTooltip, Portal } from "@chakra-ui/react";

export type TooltipProps = {
  showArrow?: boolean;
  portalled?: boolean;
  portalRef?: RefObject<HTMLElement>;
  content: ReactNode;
  contentProps?: ChakraTooltip.ContentProps;
  disabled?: boolean;
  arrowStyle?: CSSProperties;
} & ChakraTooltip.RootProps;

export const Tooltip = forwardRef<HTMLDivElement, TooltipProps>(function Tooltip(props, ref) {
  const { showArrow, children, disabled, portalled, content, contentProps, portalRef, arrowStyle, ...rest } =
    props;

  if (disabled) return children;

  return (
    <ChakraTooltip.Root {...rest}>
      <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>
      <Portal
        disabled={!portalled}
        container={portalRef}
      >
        <ChakraTooltip.Positioner>
          <ChakraTooltip.Content
            ref={ref}
            {...contentProps}
          >
            {showArrow && (
              <ChakraTooltip.Arrow style={arrowStyle}>
                <ChakraTooltip.ArrowTip />
              </ChakraTooltip.Arrow>
            )}
            {content}
          </ChakraTooltip.Content>
        </ChakraTooltip.Positioner>
      </Portal>
    </ChakraTooltip.Root>
  );
});
